var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ja-content',{attrs:{"pageActions":_vm.pageActions,"pageTitle":_vm.pageTitle}},[_c('b-card',[_c('b-card-text',[_c('form',{staticClass:"form"},[_c('ja-form-field',{attrs:{"id":"language","label":"language","type":"select","fieldValue":_vm.fieldLanguage,"options":_vm.languages,"on-change":_vm.handleChangeLanguage}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }